// extracted by mini-css-extract-plugin
export default {"PlusToArrow":"PlusToArrow_PlusToArrow__IekRQ","plus":"PlusToArrow_plus__c41vG","arrow":"PlusToArrow_arrow__FVwIA","PlusToArrowOpen":"PlusToArrow_PlusToArrowOpen__1WeC5"};